module.exports = __webpack_public_path__ + "img/feedback6-3.36ff32ca.jpg";